import { useEffect, useState, useCallback  } from "react";
import React from 'react';
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Select from "react-select";
import SuiInput from "components/SuiInput";
import MovementReasonsSelect from "../components/MovementReasonsSelect";
import CampaignProvider from "../../../providers/CampaignProvider";
import UsersProvider from "../../../providers/UsersProvider";
import { useForm } from 'react-hook-form';
import ActionRequestButtons from "../components/ActionRequestButtons";
import requesterErrorMessages from '../../../static/messages/errorMessages.json';
import ErrorMessage from "../components/ErrorMessage";

const customStyles = {
  loadingIndicator: (base) => ({
    ...base,
    color: "#ff6347",
    fontSize: '6px',
    marginRight: '1rem'
  }),
};


export const UsersMovementEscalation = React.memo(({ setApiRequestObj }) => {
  const { register, handleSubmit, formState: { errors }, reset, getValues, setValue  } = useForm();
  const requestorRoleName = localStorage.getItem('roleName');
  const [roleNameOptions] = useState([
    {key: 1, value: 'Agent' , manager :'Junior Manager'},
    {key: 2, value: 'Junior Manager',  manager :'General Manager'},
  ]);

  const rolePermittedOptions = {
    "Junior Manager": {
      canMove: ["Agent"]
    },
    "Feeder Junior Manager": {
      canMove: ["Agent"]
    },
    "General Manager": {
      canMove: ["Agent", "Junior Manager", "Feeder Junior Manager"]
    },
    "Feeder General Manager": {
      canMove: ["Agent", "Junior Manager", "Feeder Junior Manager"]
    },
    "Admin": {
      canMove: ["Agent", "Junior Manager"]
    }
  };

  const [errorMessages, setErrorMessages] = useState(null);
  const [fetchingData, setFetchingData] = useState(false);

  // Select Options
  const [suboridinateOptions, setSuboridinateOptions] = useState([]);
  const [currentManagerOptions, setManagerOptions] = useState(null);
  const [newManagerOptions, setNewManagerOptions] = useState(null);
  
  const [userRoleName, setUserRoleName] = useState('');
  const [approvers, setApprovers] = useState(null);
  const [loggedInUserRole, setLoggedInUserRole] = useState(localStorage.getItem("roleName"));
  
  const [selectedCurrentManager, setSelectedCurrentManager] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState(null);
  const [selectedNewManager, setSelectedNewManager] = useState(null);
  const [movementReasonId, setMovementReasonId] = useState(null);
  
  

  const onSubmit = () => {  
    if (!selectedNewManager || !selectedCurrentManager || !selectedUsers) return;
    if (selectedNewManager.EmployeeNumber === selectedCurrentManager.EmployeeNumber) return;

    const selectedSuborinates = selectedUsers.map((user) => ({
      Name: user.name,
      EmployeeNumber: user.value
    }))

    let approvers = [selectedNewManager?.EmployeeNumber];
    
    if(selectedNewManager?.ManagerUsers[0]?.EmployeeNumber) {
      approvers.push(selectedNewManager?.ManagerUsers[0]?.EmployeeNumber);
    } 
    
      setApiRequestObj({
        RequestType: "UPDATE CAMPAIGNS AND MANAGER",
        RequestDescription: "portal-request",
        CreatedBy: localStorage.getItem("UserName") || null,
        RequesterUserEmployeeNumber: localStorage.getItem("EmployeeNumber"),
        UserHierarchyMovementReasonId: movementReasonId,
        ApproverUserEmployeeNumbers: approvers,
        EffectiveDate: null,
        ManagerUserEmployeeNumber: selectedNewManager?.EmployeeNumber,
        EmployeeMovements: selectedSuborinates
      })     
  };

  const handleFormSubmit = handleSubmit(onSubmit);
  

  useEffect(async() => {
    // Reset all values
    setManagerOptions(null);
    setNewManagerOptions(null);
    setSelectedCurrentManager(null);
    setSelectedUsers(null);
    setSelectedNewManager(null);
    setSuboridinateOptions([]);

    let users = [];

    const fetchManager = async() => {
      getCurrentManagerInfo(localStorage.getItem("userPrincipalName"));
    }
    // if(loggedInUserRole === 'Junior Manager'){
    //   await fetchManager();
    // }
    // if(loggedInUserRole === 'General Manager' && userRoleName === 'Agent'){
    //   await fetchManager();
    // }
    // if(loggedInUserRole === 'Junior Manager'){
    //   await fetchManager();
    // }
    // if(!["Admin", "General Manager"].includes(loggedInUserRole)){
    //   await fetchManager();
    // }

    //Scenarios
    setFetchingData(true);
    if(loggedInUserRole === 'Admin'){
      if(userRoleName === 'Agent'){
        let currentManagerOptions = [];
        const [juniorManagerUsers, feederJuniorManagerUsers, trainerUsers] = await Promise.all([
          UsersProvider.getUsersByRole({ roleName: 'Junior Manager' }),
          UsersProvider.getUsersByRole({ roleName: 'Feeder Junior Manager' }),
          UsersProvider.getUsersByRole({ roleName: 'Trainer' })
        ]);
      
        currentManagerOptions = [...juniorManagerUsers, ...feederJuniorManagerUsers, ...trainerUsers];
        let options = currentManagerOptions.map((user) => ({
          value: user.EmployeeNumber	,
          label: `${user.FullName} ( ${user.EmployeeNumber} )`,
          ...user
        }));
        setManagerOptions(options);
        setNewManagerOptions(options);
      }
      else if(userRoleName === 'Junior Manager' || userRoleName === 'Feeder Junior Manager'){
        let currentManagerOptions = [];
        // currentManagerOptions = await UsersProvider.getUsersByRole({ roleName: 'General Manager' });
        const [generalManagerUsers] = await Promise.all([
          UsersProvider.getUsersByRole({ roleName: userRoleName === "Junior Manager" ? "General Manager" : userRoleName })
        ]);
        currentManagerOptions = generalManagerUsers;

        let options = currentManagerOptions.map((user) => ({
          value: user.EmployeeNumber	,
          label: `${user.FullName} ( ${user.EmployeeNumber} )`,
          ...user
        }));
        setManagerOptions(options);
        setNewManagerOptions(options);
      }
    }
    else if(loggedInUserRole === 'General Manager' || loggedInUserRole === 'Feeder General Manager'){
      if(userRoleName === 'Agent'){
        const managerData =  await UsersProvider.getUsersSearch({ userPrincipalName: localStorage.getItem("userPrincipalName") });
        let managerSubOptions = managerData[0].SubordinateUsers.map((user) => ({
          value: user.EmployeeNumber	,
          label: `${user.FullName} ( ${user.EmployeeNumber} )`,
          name: user.FullName,
          ...user
        }));
        setManagerOptions(managerSubOptions);
        
        let currentManagerOptions = [];
        const [juniorManagerUsers, feederJuniorManagerUsers, trainerUsers] = await Promise.all([
          UsersProvider.getUsersByRole({ roleName: 'Junior Manager' }),
          UsersProvider.getUsersByRole({ roleName: 'Feeder Junior Manager' }),
          UsersProvider.getUsersByRole({ roleName: 'Trainer' })
        ]);
      
        currentManagerOptions = [...juniorManagerUsers, ...feederJuniorManagerUsers, ...trainerUsers];
        let options = currentManagerOptions.map((user) => ({
          value: user.EmployeeNumber	,
          label: `${user.FullName} ( ${user.EmployeeNumber} )`,
          ...user
        }));
        setNewManagerOptions(options);
      }
      else if(userRoleName === 'Junior Manager' || userRoleName === 'Feeder Junior Manager'){
        await fetchManager();

        let newManagerOptions = [];
        const [generalManagerUsers, feederGeneralManagerUsers] = await Promise.all([
          UsersProvider.getUsersByRole({ roleName: 'Feeder General Manager' }),
          UsersProvider.getUsersByRole({ roleName: 'General Manager' })
        ]);
        newManagerOptions = [...generalManagerUsers, ...feederGeneralManagerUsers];
        // newManagerOptions = await UsersProvider.getUsersByRole({ roleName: 'General Manager' });
        let options = newManagerOptions.map((user) => ({
          value: user.EmployeeNumber	,
          label: `${user.FullName} ( ${user.EmployeeNumber} )`,
          ...user
        }));
        setNewManagerOptions(options);
      }
    }
    else if(loggedInUserRole === 'Junior Manager' || loggedInUserRole === 'Feeder Junior Manager'){
      if(userRoleName === 'Agent'){
        await getCurrentManagerInfo(localStorage.getItem("userPrincipalName"));

        let currentManagerOptions = [];
        const [juniorManagerUsers, feederJuniorManagerUsers, trainerUsers] = await Promise.all([
          UsersProvider.getUsersByRole({ roleName: 'Junior Manager' }),
          UsersProvider.getUsersByRole({ roleName: 'Feeder Junior Manager' }),
          UsersProvider.getUsersByRole({ roleName: 'Trainer' })
        ]);
      
        currentManagerOptions = [...juniorManagerUsers, ...feederJuniorManagerUsers, ...trainerUsers];
        let options = currentManagerOptions.map((user) => ({
          value: user.EmployeeNumber	,
          label: `${user.FullName} ( ${user.EmployeeNumber} )`,
          ...user
        }));
        setNewManagerOptions(options);
      }
    }

    
    // const userManagerRole = roleNameOptions.find(role => role.value === roleName);
    //Setting Manager Options only if necessary
    // if (userRoleName === 'Agent') {
    //   const [juniorManagerUsers, trainerUsers] = await Promise.all([
    //     UsersProvider.getUsersByRole({ roleName: 'Junior Manager' }),
    //     UsersProvider.getUsersByRole({ roleName: 'Trainer' })
    //   ]);
    
    //   // Combine the arrays
    //   users = [...juniorManagerUsers, ...trainerUsers];
    // }else{
    //   users = await UsersProvider.getUsersByRole({ roleName: userManagerRole.manager });
    // }


    // let options = users.map((user) => ({
    //   value: user.EmployeeNumber	,
    //   label: `${user.FullName} ( ${user.EmployeeNumber} )`,
    //   ...user
    // }));

    // if(loggedInUserRole === 'Admin' && roleName === 'Agent'){
    //   const agents = await UsersProvider.getUsersByRole({ roleName: 'Agent' });
    //   setSuboridinateOptions(agents);
    // }

    // if(loggedInUserRole === 'General Manager' && roleName === 'Junior Manager'){
    //   const agents = await getCurrentManagerInfo()
    //   setSuboridinateOptions(agents);
    // }

    setFetchingData(false);
    // setManagerOptions(options);
  }, [userRoleName])

  useEffect(async() => {
    setErrorMessages(requesterErrorMessages['teamManagement'].requests['usersMovementRequest']);   
  }, [])

  const getUsers = async(roleName) => {
   
  };

  const fetchUsers = async(roleName) => {
    
  };

  const getCurrentManagerInfo = async(userPrincipalName) => {
    setFetchingData(true);
    const managerData = await UsersProvider.getUsersSearch({ userPrincipalName: userPrincipalName });

    if(managerData && managerData.length === 1){
      setSelectedCurrentManager(managerData[0]);
      if(managerData[0].SubordinateUsers && managerData[0].SubordinateUsers.length > 0){
        let options = managerData[0].SubordinateUsers.map((user) => ({
          value: user.EmployeeNumber	,
          label: `${user.FullName} ( ${user.EmployeeNumber} )`,
          name: user.FullName
        }));
        setSuboridinateOptions(options);
        // setFetchingData(false);

      }else{
        setSuboridinateOptions([]);
      }
    }
    setFetchingData(false);
  }
  
  const getNewManagerInfo = async(userPrincipalName) => {
    setFetchingData(true);
    const managerData = await UsersProvider.getUsersSearch({ userPrincipalName: userPrincipalName });
    if(managerData && managerData.length === 1){
      setSelectedNewManager(managerData[0]);
    }

    setFetchingData(false);
  }
  
  return (
    <>
    {errorMessages && <>
          
        {!["Admin", "General Manager", "Feeder General Manager"].includes(loggedInUserRole) && <>
          <SuiTypography variant="h6">Current Manager (You)</SuiTypography>
          <SuiInput
            label={`User`}
            id={`userEscalationRef`}
            name={`userEscalationRef`}
            disabled={true}
            value={`${localStorage.getItem("fullName")} ( ${localStorage.getItem("EmployeeNumber")} )`}
          />
        </>}
      <SuiBox mt={4} mb={2} lineHeight={1}>
        <SuiTypography variant="h6">User Movement Role</SuiTypography>
        <SuiBox position="relative">
          <Select
            key={`roleName`}
            id={`roleName`}
            register={register('roleName', errorMessages['roleName'])}
            options={rolePermittedOptions[requestorRoleName].canMove.map((role) => ({ value: role, label: role })) || []}
            placeholder={`Select the user's role you want to move`}
            onChange={(e) => {setUserRoleName(e.value); userRoleName !== e.value? reset() : ''; setValue('roleName', e.value);}}
            isSearchable={false}
            classNamePrefix="custom-select"
            className="select-control select-one select-with-html"
          />
        </SuiBox>
        {errors['roleName'] && <p className="error msg pad">{errorMessages['roleName']['required']}</p>}
      </SuiBox>
      <SuiBox mt={4} mb={2} lineHeight={1}>
        {loggedInUserRole === 'Admin' && 
        <>
          <SuiTypography variant="h6">Current Manager</SuiTypography>
          <SuiBox mt={1} position="relative">
          <Select
            key={`currentManagerOptions`}
            id={`currentManagerOptions`}
            register={register('currentManagerOptions', errorMessages['currentManagerOptions'])}
            isLoading={fetchingData}
            styles={customStyles}
            options={currentManagerOptions || []}
            placeholder={`Select the manager you want to move users from`}
            onChange={(e) => {getCurrentManagerInfo(e.UserPrincipalName); setValue('currentManagerOptions', e.value);}}
            isSearchable={fetchingData}
            classNamePrefix="custom-select"
            className="select-control select-one select-with-html"
            value={selectedCurrentManager && {
              label: `${selectedCurrentManager.FullName} ( ${selectedCurrentManager.EmployeeNumber} )`,
              value: selectedCurrentManager.FullName
            }}
          />
          </SuiBox>
          {errors['currentManagerOptions'] && <p className="error msg pad">{errorMessages['currentManagerOptions']['required']}</p>}
        </>}
        {(loggedInUserRole === 'General Manager' || loggedInUserRole === 'Feeder General Manager') && userRoleName === 'Agent' && 
        <>
          <SuiTypography variant="h6">Current Manager</SuiTypography>
          <SuiBox mt={1} position="relative">
          <Select
            key={`currentManagerOptions`}
            id={`currentManagerOptions`}
            register={register('currentManagerOptions', errorMessages['currentManagerOptions'])}
            isLoading={fetchingData}
            styles={customStyles}
            options={currentManagerOptions || []}
            placeholder={`Select the manager you want to move users from`}
            onChange={(e) => {getCurrentManagerInfo(e.UserPrincipalName); setValue('currentManagerOptions', e.value);}}
            isSearchable={fetchingData}
            classNamePrefix="custom-select"
            className="select-control select-one select-with-html"
            value={selectedCurrentManager && {
              label: `${selectedCurrentManager.FullName} ( ${selectedCurrentManager.EmployeeNumber} )`,
              value: selectedCurrentManager.FullName
            }}
          />
          </SuiBox>
          {errors['currentManagerOptions'] && <p className="error msg pad">{errorMessages['currentManagerOptions']['required']}</p>}
        </>}
      </SuiBox>
      <SuiBox mt={4} mb={6} lineHeight={1}>
        <SuiTypography variant="h6">{userRoleName || 'User'}s to Move</SuiTypography>
        <SuiBox mt={1} position="relative">
          <Select
            key={`userOptions`}
            id={`userOptions`}
            register={register('userOptions', errorMessages['userOptions'])}
            isLoading={fetchingData}
            isDisabled={fetchingData || !suboridinateOptions}
            styles={customStyles}
            options={suboridinateOptions || []}
            placeholder={`Select the users to want to move from ${selectedCurrentManager?.FullName || 'current manager'}`}
            onChange={(e) => {setSelectedUsers(!Array.isArray(e) ? [e] : e); setValue('userOptions', e);}}
            isSearchable={true}
            isMulti={userRoleName === 'Agent' ? true : false}
            classNamePrefix="custom-select"
            className="select-control select-one select-with-html"
            value={selectedUsers}

          />
        </SuiBox>
        {errors['userOptions'] && <p className="error msg pad">{errorMessages['userOptions']['required']}</p>}
      </SuiBox>

      <SuiBox mt={6} mb={2} lineHeight={1}>
        <SuiTypography variant="h6">New Manager Selection</SuiTypography>
        <SuiBox mt={1} position="relative">
          <Select
            key={`newManagerOptions`}
            id={`newManagerOptions`}
            register={register('newManagerOptions', errorMessages['newManagerOptions'])}
            isLoading={fetchingData}
            isDisabled={fetchingData}
            styles={customStyles}
            options={newManagerOptions || []}
            placeholder={`Select the manager you want to move users to`}
            onChange={(e) => {getNewManagerInfo(e.UserPrincipalName); setValue('newManagerOptions', e.value);}}
            isSearchable={true}
            classNamePrefix="custom-select"
            className="select-control select-one select-with-html"
            value={selectedNewManager && {
              label: `${selectedNewManager.FullName} ( ${selectedNewManager.EmployeeNumber} )`,
              value: selectedNewManager.FullName
            }}
          />
        </SuiBox>
        {errors['newManagerOptions'] && <p className="error msg pad">{errorMessages['newManagerOptions']['required']}</p>}
        {selectedNewManager && 
        selectedCurrentManager && 
        selectedNewManager.EmployeeNumber === selectedCurrentManager.EmployeeNumber && <p className="error msg pad">Current and New Manager can't be the same</p>}      
      </SuiBox>

      <MovementReasonsSelect
        requestType={'movement'} 
        setReasonId={setMovementReasonId} 
        register={register}
        errorMessages={errorMessages}
        errors={errors} 
        setValue={setValue}
       />
      <ActionRequestButtons onSubmit={handleFormSubmit} isDisabled={fetchingData}
      />
    </>}
    </>
  )
});
